export default {
  // successes
  ENROLLMENT_UPDATE_SUCCESS: "You have successfully updated your enrollment.",
  ENROLLMENT_RENEW_SUCCESS: "You have successfully renewed your enrollment.",
  ENROLLMENT_CANCEL_SUCCESS: "You have successfully cancelled your enrollment.",
  ENROLLMENT_SUCCESS: "You have successfully enrolled.",
  UNCOMP_SUCCESS: "Uncomped and charged.",

  // warnings
  UNCOMP_PAYMENT_REQUIRED:
    "Uncomped, but the charge didn't go through — the user will be asked for a card when they log in.",

  // errors
  ERROR_UPGRADING_ENROLLMENT: "There was an error upgrading enrollment.",
  ERROR_DOWNGRADING_ENROLLMENT: "There was an error downgrading enrollment.",
  ERROR_FETCHING_UPGRADE_PREVIEW: "There was an error fetching upgrade details.",
  ERROR_FETCHING_ENROLLMENTS: "There was an error fetching enrollments",
  ERROR_FETCHING_CHARGES: "There was an error fetching charges",
  ENROLLMENT_RENEW_ERROR: "There was an error renewing your enrollment.",
  ENROLLMENT_CANCEL_ERROR: "There was an error canceling your enrollment.",
  ENROLLMENT_ERROR: "There was an error processing your enrollment.",
  ERROR_UNCOMPING_ENROLLMENT: "There was an error uncomping this user's enrollment.",
  // INSERTION_PT (for script, do not remove)
};
